/**
 * 判断iphone型号
 */

export function getPhoneType() {
    let isBigScreen = false; //默认iphone不是全面屏
    let ua = window.navigator.userAgent;
    let deviceScreen = window.screen.width + ',' + window.screen.height;
    let iPhoneScreen = [
        '375,812',  // X、XS、11 Pro
        '414,896',  // XR、11、Xs Max、11 Pro Max
        '390,844',  // 12、12 Pro
        '428,926',  // 12 Pro Max
    ]
    //ua.indexOf('MicroMessenger') > -1
    if ((ua.indexOf('MicroMessenger') > -1 || labor.isApp()) && !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) && iPhoneScreen.indexOf(deviceScreen) > -1) {
        isBigScreen = true;
    }
    return isBigScreen;
}